import refusal from './letters-signing-refusals-ms'

/**
 * Sijil tandatangan (planning P4-3b D-587 hingga D-589): Tetapan → Perancangan → Sijil tandatangan, "Tandatangan dalam
 * gisify" pada panel Surat (`panel.*`) dan senarai pemegang sendiri (`mine.*`). Terjemahan sebenar.
 */
export default {
  title: 'Sijil tandatangan',
  intro:
    'gisify boleh menandatangani surat yang dikeluarkan dengan sijil yang disimpan oleh majlis ini di sini. Apa yang dibuktikan oleh tandatangan sedemikian kepada pihak di luar gisify: surat itu tidak berubah sejak ditandatangani, dan ia ditandatangani dengan sijil majlis ini. Setiap sijil di bawah sijil akar majlis menamakan organisasi yang sama dengan sijil akar: nama majlis pada kepala suratnya semasa sijil akar dibuat. Pembaca yang belum mempercayai sijil akar majlis akan melihat penandatangan sebagai tidak dikenali. Tiada cap masa atau data pembatalan disertakan. Sesiapa yang menceroboh gisify boleh menandatangani surat atas nama majlis.',
  root: {
    title: 'Sijil akar majlis',
    create: 'Cipta sijil akar majlis',
    help: 'Berikan sijil ini kepada sesiapa yang perlu menyemak surat anda. Mereka menambahnya sekali dalam Adobe Reader, di bawah Trusted Certificates, untuk tandatangan sahaja. Sijil ini tidak boleh sekali-kali ditambah ke stor sijil akar komputer atau pelayar. Sesiapa yang menceroboh gisify boleh menandatangani surat atas nama majlis ini dengannya.',
  },
  download: { cer: 'Muat turun (.cer)', pem: 'Muat turun (.pem)' },
  fingerprint: 'Cap jari SHA-256',
  issue: { title: 'Keluarkan sijil tandatangan', submit: 'Keluarkan' },
  upload: {
    title: 'Muat naik cop majlis',
    sealOnly:
      'Pentadbir memuat naik cop majlis di sini. Sijil peribadi dimuat naik oleh orang yang dinamakan padanya, melalui Sijil tandatangan saya pada senarai perancangan.',
    submit: 'Muat naik',
  },
  fields: {
    label: 'Label sijil',
    commonName: 'Nama pada sijil',
    organization: 'Organisasi',
    organizationFixed:
      'Setiap sijil di bawah sijil akar ini menamakan {{council}}, iaitu majlis pada kepala surat semasa sijil akar dibuat. Untuk mengubahnya, padam sijil akar dan cipta yang baharu.',
    commonNameRootDefault:
      'Biarkan kosong untuk menggunakan nama majlis diikuti "Letter Root", atau nama itu sahaja jika ia akan melebihi 64 aksara. Anda boleh menaip nama yang lebih pendek.',
    organizationalUnit: 'Unit (pilihan)',
    country: 'Kod negara (pilihan, contohnya MY)',
    copyFromSignatory: 'Salin nama penandatangan',
    binding: 'Siapa boleh menggunakannya',
    person: 'Orang',
    format: { pkcs12: 'Fail PKCS#12 (.p12, .pfx)', pem: 'Kunci dan rantaian PEM' },
    password: 'Kata laluan fail',
    passwordNote:
      'Kata laluan digunakan sekali untuk membuka fail dan kemudian dikeluarkan daripada gisify. Salinan dalam sandaran pangkalan data luput bersama sandaran itu.',
    file: 'Fail',
    keyFile: 'Kunci persendirian (.pem, .key)',
    chainFile: 'Sijil dan rantaian (.pem, .crt)',
    keyPassword: 'Kata laluan kunci, jika ada',
  },
  binding: { personal: 'Orang ini sahaja', seal: 'Mana-mana pegawai yang boleh menandatangani surat itu (cop majlis)' },
  kind: { root: 'Sijil akar majlis', signing: 'Sijil tandatangan' },
  source: { generated: 'Dibuat dalam gisify', uploaded: 'Dimuat naik' },
  approve: {
    title: 'Luluskan sijil peribadi',
    selfSigned: 'Ditandatangani sendiri',
    body: 'Luluskan hanya jika nama itu nama pegawai ini sendiri dan cap jari sepadan dengan cap jari yang diberikan oleh pegawai itu. Setelah diluluskan, surat yang ditandatangani dengan sijil ini dipercayai dalam gisify dan boleh dikongsi secara automatik. Menyahdayakannya akan membatalkan kelulusan.',
    commonName: 'Nama yang dibandingkan dengan penandatangan surat',
    subject: 'Subjek penuh',
    nameNone: 'Sijil ini tiada nama yang boleh dibandingkan oleh gisify.',
    nameMoreThanOne: 'Sijil ini mempunyai lebih daripada satu nama.',
    nameUnclear: 'Sijil ini tidak boleh diluluskan: gisify membandingkan tepat satu nama dengan penandatangan.',
    subjectCut:
      'Subjek penuh lebih panjang daripada yang ditunjukkan oleh gisify. Buat keputusan berdasarkan nama di atas, bukan hujung subjek.',
    hiddenCharacters:
      'Nama atau subjek mengandungi aksara tersembunyi atau aksara yang mengubah arah tulisan, ditunjukkan di sini sebagai kod. Jangan luluskan melainkan anda tahu sebab aksara itu ada.',
  },
  actions: {
    approve: 'Luluskan',
    disable: 'Nyahdayakan',
    enable: 'Dayakan',
    delete: 'Padam',
    cancel: 'Batal',
    refresh: 'Semak semula',
  },
  confirm: {
    delete:
      'Padam sijil ini? Kunci persendiriannya dikeluarkan daripada gisify dan ia tidak boleh menandatangani lagi. Salinan dalam sandaran pangkalan data luput bersama sandaran itu. Surat yang telah ditandatangani dengannya tidak terjejas.',
    deleteRoot: 'Bersama sijil akar, setiap sijil tandatangan yang dikeluarkannya turut dipadam.',
    disableApproved:
      'Menyahdayakan sijil ini turut membatalkan kelulusannya. Jika ia didayakan semula, pentadbir mesti meluluskannya sekali lagi.',
  },
  warning: {
    holderNotQualified:
      'Orang yang terikat pada sijil ini tidak lagi boleh menandatangani surat, jadi surat yang ditandatangani dengannya tidak dipercayai. Nyahdayakan atau padamkannya.',
    chainIncomplete:
      'Fail itu tidak menyertakan rantaian penuh hingga ke sijil akar. Pembaca di luar gisify mungkin tidak dapat menyemak sijil ini.',
    icNumber:
      'Sijil ini membawa nombor kad pengenalan. Setiap surat yang ditandatangani dengannya memerlukan pengesahan pegawai sebelum dikongsi.',
  },
  limits:
    'Sijil daripada CA dalam Adobe Approved Trust List, serta sijil token atau perayauan Malaysia, menyimpan kuncinya pada peranti dan tidak boleh dimuat naik. Tandatangani surat itu dengan alat anda sendiri dan muat naik fail yang telah ditandatangani.',
  status: {
    pending: 'Sedang disediakan…',
    pendingSlow: 'Ini mengambil masa lebih lama daripada dijangka.',
    active: 'Sedia',
    disabled: 'Dinyahdayakan',
    deleted: 'Dipadam: kuncinya telah dikeluarkan daripada gisify',
    refused: 'Tidak diterima',
    expired: 'Tamat tempoh',
    notYetValid: 'Sah mulai {{date}}',
    awaitingApproval: 'Sedia untuk menandatangani. Surat menunggu pegawai sehingga pentadbir meluluskannya.',
  },
  expires: 'Tamat tempoh {{date}}',
  expiringSoon: 'Tamat tempoh dalam {{days}} hari',
  folded: 'Dipadam dan tidak diterima ({{count}})',
  problems: {
    required: 'Isikan medan ini.',
    tooLong: 'Paling banyak {{max}} aksara.',
    control: 'Buang aksara kawalan itu.',
    country: 'Gunakan dua huruf besar, contohnya MY.',
    fileMissing: 'Pilih fail.',
    fileTooLarge: 'Fail itu melebihi {{max}} KiB.',
    person: 'Pilih orang.',
  },
  panel: {
    button: 'Tandatangan dalam gisify',
    title: 'Tandatangani surat dalam gisify',
    choose: 'Pilih sijil',
    what: 'gisify menandatangani surat yang dikeluarkan dengan sijil ini, kemudian menyemaknya sama seperti fail yang dimuat naik.',
    sealNote: 'Cop majlis tidak menamakan penandatangan, jadi surat itu akan menunggu pegawai untuk mengongsikannya.',
    unapprovedNote: 'Pentadbir belum meluluskan sijil ini, jadi surat itu akan menunggu pegawai untuk mengongsikannya.',
    sign: 'Tandatangani',
    signedWith: 'Ditandatangani dalam gisify dengan {{label}} pada {{time}}',
    binding: { personal: 'Sijil peribadi', seal: 'Cop majlis' },
    refusal: {
      signing_certificate_unusable:
        'gisify tidak menandatangani surat ini: sijil yang dipilih tidak lagi boleh menandatangani. Pilih sijil lain, atau tandatangani fail yang dikeluarkan dengan alat anda sendiri dan muat naik fail itu.',
      signing_key_unreadable:
        'gisify tidak menandatangani surat ini: kunci persendirian sijil itu tidak dapat dibuka. Pentadbir perlu mengeluarkan atau memuat naik sijil itu sekali lagi.',
      signing_failed:
        'gisify tidak dapat menandatangani surat ini dengan sijil itu. Cuba lagi, dan beritahu pentadbir jika ia berlaku lagi.',
      unknown:
        'gisify tidak dapat menandatangani surat ini. Cuba lagi, atau tandatangani fail yang dikeluarkan dengan alat anda sendiri dan muat naik fail itu.',
      dispatch_failed: 'gisify tidak dapat mula menandatangani surat ini. Klik Tandatangan dalam gisify sekali lagi.',
      verify_timeout:
        'Penandatanganan dan semakan mengambil masa terlalu lama, lalu dihentikan. Klik Tandatangan dalam gisify sekali lagi.',
    },
  },
  mine: {
    title: 'Sijil tandatangan saya',
    open: 'Sijil tandatangan saya',
    intro:
      'Hanya anda boleh memuat naik dan menggunakan sijil peribadi yang terikat kepada anda. Tiada orang lain, termasuk pentadbir, boleh memuat naiknya bagi pihak anda. Pentadbir meluluskannya sebelum surat yang ditandatangani dengannya boleh dikongsi secara automatik.',
    upload: 'Muat naik sijil saya',
    empty: 'Anda belum mempunyai sijil tandatangan.',
    close: 'Tutup',
  },
  refusal,
}
